export function telLinks() {
  const links = document.querySelectorAll("a");

  if (!links.length) return;

  links.forEach((link) => {
    const href = link.getAttribute("href");
  
    // Check if href exists and is only numbers then convert link to tel link
    if (href && /^\d+$/.test(href)) {
      link.setAttribute("href", `tel:${href}`);
    }
  });
}